import { prepareCommonCarriageData, sendCarriage } from "~/features/configurator/Carriage/api/sendCarriageCommon";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { getMainKmat } from "~/features/configurator/Shaft/common/commonShaftHelpers";
import { FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE } from "~/features/configurator/Carriage/carriageConfiguratorConstants";
import { isNonNull } from "~/common/utils/reducers";

export async function sendCarriageStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonCarriageData(linearState);

  data.cpqAction = "NAV_TO_CSTIC_IN_GROUP";
  // data.carriagesConfiguratorData.navigation = true;

  const response = await sendCarriage(data);

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transform(response, ConfiguratorType.Carriage, csticsToPreserve);
}

export async function sendCarriageMiscChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonCarriageData(linearState);

  data.cpqAction = "TOGGLE_GROUP";

  const response = await sendCarriage(data);

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transform(response, ConfiguratorType.Carriage, csticsToPreserve);
}
